import { Chip } from "@mui/material";

export const ROLES = [
  { value: "super_admin", label: "Super Admin", color: "error" },
  { value: "operator", label: "Operator", color: "primary" },
  { value: "support", label: "Support", color: "warning" },
  { value: "read_only", label: "Read Only", color: "default" },
];

export function getRoleChip(role) {
  const found = ROLES.find((r) => r.value === role);
  return (
    <Chip
      label={found?.label ?? role}
      color={found?.color ?? "default"}
      size="small"
    />
  );
}
